import {
  Action,
  SET_IS_LOADING,
  SET_IS_LOADING_MORE,
  SET_NEXT_DATA,
  SET_NEW_DATA,
  SET_HAS_ERROR,
  SET_ERROR_MESSAGE,
  SetIsLoadingAction,
  SetIsLoadingMoreAction,
  SetLoadMoreResponseAction,
  SetLoadNewResponseAction,
  SetHasErrorAction,
  SetErrorMessageAction,
} from "./actions";

import { hasPaginationNextItems } from "../utils";

export interface State<TItem> {
  hasNextItems: boolean;
  isLoading: boolean;
  isLoadingMore: boolean;
  items: TItem[];
  pagination: Pagination;
  errorMessage: string;
  hasError: boolean;
}

const reducer = <TItem>(state: State<TItem>, action: Action<TItem>): State<TItem> => {
  const { type } = action;

  switch (type) {
    case SET_NEXT_DATA: {
      const { payload } = action as SetLoadMoreResponseAction<TItem>;

      return {
        ...state,
        hasNextItems: hasPaginationNextItems(payload.pagination),
        items: [...state.items, ...payload.data],
        pagination: payload.pagination,
        hasError: false,
      };
    }

    case SET_NEW_DATA: {
      const { payload } = action as SetLoadNewResponseAction<TItem>;

      return {
        ...state,
        hasNextItems: hasPaginationNextItems(payload.pagination),
        items: payload.data,
        pagination: payload.pagination,
        hasError: false,
      };
    }

    case SET_IS_LOADING: {
      const { payload } = action as SetIsLoadingAction;

      return {
        ...state,
        isLoading: payload,
      };
    }

    case SET_IS_LOADING_MORE: {
      const { payload } = action as SetIsLoadingMoreAction;

      return {
        ...state,
        isLoadingMore: payload,
      };
    }

    case SET_HAS_ERROR: {
      const { payload } = action as SetHasErrorAction;

      return {
        ...state,
        hasError: payload,
      };
    }

    case SET_ERROR_MESSAGE: {
      const { payload } = action as SetErrorMessageAction;

      return {
        ...state,
        errorMessage: payload,
      };
    }

    default:
      return state;
  }
};

export default reducer;
